import React, { useState, useEffect } from "react";
import { Field, Input, makeStyles } from "@fluentui/react-components";
import { getSenderEmailAddress } from "../../../utils/OfficeApiHelper";

const useStyles = makeStyles({
  readOnly: {
    "& input": {
      cursor: "default",
      backgroundColor: "transparent",
    },
    "&::after": {
      display: "none",
    }
  }
});

const EmailField = ({ name, label, value, error, readOnly = false, onChange }) => {
  const styles = useStyles();
  const [internalError, setInternalError] = useState(null);
  const [emailValue, setEmailValue] = useState(value || "");

  useEffect(() => {
    if (!value) {
      getSenderEmailAddress((email) => {
        if (email) {
          setEmailValue(email);
          onChange(name, email);
        }
      });
    }
  }, [value, name, onChange]);

  useEffect(() => {
    if (emailValue && !validateEmail(emailValue)) {
      setInternalError("Invalid email address");
    } else {
      setInternalError(null);
    }
  }, [emailValue]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleInputChange = (e) => {
    if (readOnly) return;
    const newValue = e.target.value;
    setEmailValue(newValue);
    onChange(name, newValue);
  };

  return (
    <Field
      label={label}
      validationState={internalError || error ? "error" : "none"}
      validationMessage={internalError || error}
    >
      <Input 
        type="email" 
        value={emailValue} 
        onChange={handleInputChange} 
        readOnly={readOnly} 
        className={readOnly ? styles.readOnly : ""} />
    </Field>
  );
};

export default EmailField;
